<template>
  <div>
    <Pane />

    <a-card class="container">
      <a-form-model layout="inline" @keyup.enter.native="query">
        <a-row>
          <a-col :span="22">
            <a-form-model-item>
              <a-range-picker v-model="form.date" />
            </a-form-model-item>

            <a-form-model-item>
              <a-input
                v-model="form.applicantName"
                placeholder="申领人"
                style="width: 160px"
              />
            </a-form-model-item>

            <a-form-model-item>
              <a-space>
                <a-button @click="query" type="primary">查询</a-button>
                <a-button @click="reset">重置</a-button>
                <a-button @click="exportExcel" :loading="exportLoading" type="primary" ghost>
                  导出
                </a-button>
              </a-space>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>

      <Padding />

      <a-table
        rowKey="id"
        :dataSource="list"
        :loading="loading"
        :expandIcon="renderExpandIcon"
        :expandedRowKeys="expandedRowKeys"
        @expandedRowsChange="onExpandedRowsChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
        @change="onChange"
      >
        <a-table-column title="申领人" data-index="applicantName" width="120px">
        </a-table-column>
        <a-table-column title="所属部门" data-index="deptName" width="180px">
        </a-table-column>
        <a-table-column title="申领事由" data-index="remarks" :ellipsis="true">
        </a-table-column>
        <a-table-column title="领用时间" width="150px">
          <template slot-scope="text">{{
            text.createAt ? moment(text.createAt).format("YYYY-MM-DD HH:mm") : ""
          }}</template>
        </a-table-column>
        <a-table-column title="审批通过时间" width="150px">
          <template slot-scope="text">
            <span v-if="text.status === 'approved' && text.updateAt">{{
              moment(text.updateAt).format("YYYY-MM-DD HH:mm")
            }}</span>
          </template>
        </a-table-column>
        <a-table-column title="状态" width="100px" align="center">
          <template slot-scope="text">
            <a-tag :color="statusMap[text.status] ? statusMap[text.status].color : ''">
              {{
                statusMap[text.status] ? statusMap[text.status].name : text.status
              }}
            </a-tag>
          </template>
        </a-table-column>
        <a-table-column title="操作" width="80px" align="center">
          <template slot-scope="text">
            <a-tooltip title="修改日志" v-if="text.hasLog">
              <a href="#" @click.stop="showLog(text)">
                <a-icon type="history" style="font-size: 16px" />
              </a>
            </a-tooltip>
          </template>
        </a-table-column>

        <a-table
          slot="expandedRowRender"
          slot-scope="record"
          rowKey="id"
          size="small"
          :pagination="false"
          :dataSource="detailMap[record.id] || []"
          :loading="detailLoadingId === record.id"
        >
          <a-table-column title="礼品名称">
            <template slot-scope="text">{{
              text.materialVo ? text.materialVo.name : ""
            }}</template>
          </a-table-column>
          <a-table-column title="单位" width="80px" align="center">
            <template slot-scope="text">{{
              text.materialVo ? text.materialVo.unit : ""
            }}</template>
          </a-table-column>
          <a-table-column title="单价(元)" width="110px" align="center">
            <template slot-scope="text">{{ text.unitPrice }}</template>
          </a-table-column>
          <a-table-column title="领用数量" width="200px" align="center">
            <template slot-scope="text">
              <a-tooltip
                v-if="text.applyStatus !== 'approved'"
                title="只有申领通过的记录才能修改"
              >
                <a-input-number
                  size="small"
                  :min="0"
                  :precision="0"
                  disabled
                  style="width: 90px"
                  :value="text.editQuantity"
                />
              </a-tooltip>
              <template v-else>
                <a-input-number
                  size="small"
                  :min="0"
                  :precision="0"
                  v-model="text.editQuantity"
                  style="width: 90px"
                />
                <a-button
                  type="link"
                  size="small"
                  :disabled="
                    text.editQuantity === text.quantity ||
                    text.editQuantity == null ||
                    text.editQuantity < 0
                  "
                  @click="saveQuantity(text)"
                  >保存</a-button
                >
              </template>
            </template>
          </a-table-column>
          <a-table-column title="金额(元)" width="110px" align="center">
            <template slot-scope="text">
              <span style="color: #1890ff">{{
                (text.unitPrice * (text.editQuantity || 0)).toFixed(2)
              }}</span>
            </template>
          </a-table-column>
        </a-table>
      </a-table>
    </a-card>

    <a-modal
      title="修改日志"
      :visible="logVisible"
      :width="760"
      :footer="null"
      destroyOnClose
      @cancel="closeLog"
    >
      <a-table
        :key="currentLogApplyId"
        rowKey="id"
        size="small"
        :dataSource="logList"
        :loading="logLoading"
        :pagination="false"
      >
        <a-table-column title="申领人" data-index="applicantName" width="90px">
        </a-table-column>
        <a-table-column title="所属部门" data-index="deptName" width="140px">
          <template slot-scope="text">{{
            text.deptName || "-"
          }}</template>
        </a-table-column>
        <a-table-column title="礼品名称" data-index="materialName">
        </a-table-column>
        <a-table-column title="修改内容" width="110px" align="center">
          <template slot-scope="text">
            <span style="color: #999; text-decoration: line-through">{{
              text.oldQuantity
            }}</span>
            <a-icon type="arrow-right" style="margin: 0 6px; color: #999" />
            <span style="color: #1890ff">{{ text.newQuantity }}</span>
          </template>
        </a-table-column>
        <a-table-column title="修改人" data-index="createName" width="90px">
        </a-table-column>
        <a-table-column title="修改时间" width="150px">
          <template slot-scope="text">{{
            text.createAt ? moment(text.createAt).format("YYYY-MM-DD HH:mm") : ""
          }}</template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import {
  fetchApplyRecord,
  fetchApplyDetail,
  updateApplyQuantity,
  fetchApplyRecordLog,
  exportApplyRecord,
} from "@/api/oa/gift";
import { saveAs } from "file-saver";
import moment from "moment";

export default {
  name: "giftRecord",
  mixins: [watermark],

  data() {
    return {
      form: {},
      loading: false,
      list: [],
      current: 1,
      pageSize: 10,
      total: 0,

      exportLoading: false,

      expandedRowKeys: [],
      detailMap: {},
      detailLoadingId: "",

      logVisible: false,
      logLoading: false,
      logList: [],
      currentLogApplyId: "",

      statusMap: {
        notReady: { name: "申领中", color: "blue" },
        approved: { name: "申领通过", color: "green" },
        cancelled: { name: "申领失败", color: "red" },
      },
    };
  },

  mounted() {
    this.getList();
  },

  watch: {
    //任何方式关闭抽屉都清空日志内容
    logVisible(val) {
      if (!val) {
        this.logList = [];
        this.logLoading = false;
        this.currentLogApplyId = "";
      }
    },
  },

  methods: {
    moment,

    getList() {
      const { date, applicantName } = this.form;
      let startDate, endDate;
      if (Array.isArray(date) && date.length === 2) {
        startDate = date[0].format("YYYY-MM-DD");
        endDate = date[1].format("YYYY-MM-DD");
      }

      this.loading = true;
      fetchApplyRecord({
        pageNum: this.current,
        pageSize: this.pageSize,
        applicantName,
        startDate,
        endDate,
      })
        .then((res) => {
          this.loading = false;
          this.list = res.list || [];
          this.total = res.totalSize ? res.totalSize : 0;
          //刷新后未保存的编辑恢复为已保存的值
          Object.keys(this.detailMap).forEach((id) => {
            this.detailMap[id].forEach((row) => {
              row.editQuantity = row.quantity;
            });
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },

    query() {
      this.current = 1;
      this.getList();
    },

    //按当前筛选条件导出领用明细，不选时间范围则导出全部
    exportExcel() {
      const { date, applicantName } = this.form;
      let startDate, endDate;
      if (Array.isArray(date) && date.length === 2) {
        startDate = date[0].format("YYYY-MM-DD");
        endDate = date[1].format("YYYY-MM-DD");
      }

      this.exportLoading = true;
      exportApplyRecord({
        applicantName,
        startDate,
        endDate,
      })
        .then((blob) => {
          saveAs(blob, "礼品领用记录.xlsx");
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },

    reset() {
      this.form = {};
      this.query();
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    renderExpandIcon({ expanded, record, onExpand }) {
      const h = this.$createElement;
      return h("a-icon", {
        props: { type: expanded ? "minus-square" : "plus-square" },
        style: {
          cursor: "pointer",
          color: "#1890ff",
          fontSize: "14px",
          marginTop: "2px",
        },
        on: {
          click: (e) => onExpand(record, e),
        },
      });
    },

    onExpandedRowsChange(rows) {
      //折叠的行丢弃未保存的编辑，下次展开重新拉取服务器数据
      this.expandedRowKeys.forEach((id) => {
        if (!rows.includes(id)) {
          this.$delete(this.detailMap, id);
        }
      });
      this.expandedRowKeys = rows;
      //展开时按需加载领用明细
      rows.forEach((id) => {
        if (!this.detailMap[id]) {
          this.loadDetail(id);
        }
      });
    },

    loadDetail(applyId) {
      this.detailLoadingId = applyId;
      fetchApplyDetail({ id: applyId })
        .then((res) => {
          this.detailLoadingId = "";
          const materials = Array.isArray(res.applyMaterials)
            ? res.applyMaterials
            : [];
          this.$set(
            this.detailMap,
            applyId,
            materials.map((item) => ({
              ...item,
              applyId,
              applyStatus: res.status,
              editQuantity: item.quantity,
            }))
          );
        })
        .catch(() => {
          this.detailLoadingId = "";
        });
    },

    saveQuantity(text) {
      if (
        text.applyStatus !== "approved" ||
        text.editQuantity === text.quantity ||
        text.editQuantity == null ||
        text.editQuantity < 0
      ) {
        return;
      }
      this.detailLoadingId = text.applyId;
      updateApplyQuantity({
        id: text.id,
        quantity: text.editQuantity,
      })
        .then(() => {
          this.loadDetail(text.applyId);
          this.getList();
        })
        .catch(() => {
          this.loadDetail(text.applyId);
        });
    },

    showLog(record) {
      //打开前清空旧日志，避免残留上一次的内容
      this.currentLogApplyId = record.id;
      this.logVisible = true;
      this.logLoading = true;
      this.logList = [];
      fetchApplyRecordLog(record.id)
        .then((res) => {
          //丢弃过期响应（切换记录后晚到的旧请求）
          if (this.currentLogApplyId !== record.id) {
            return;
          }
          this.logLoading = false;
          this.logList = Array.isArray(res) ? res : [];
        })
        .catch(() => {
          if (this.currentLogApplyId !== record.id) {
            return;
          }
          this.logLoading = false;
          this.logList = [];
        });
    },

    closeLog() {
      this.logVisible = false;
      this.logLoading = false;
      this.logList = [];
      this.currentLogApplyId = "";
    },
  },
};
</script>
